export default __webpack_public_path__ + "static/media/83.f52c92cd.jpeg";